export default __webpack_public_path__ + "9e9611983998bf3f192dcbfb32b36cbd.svg";